module.exports = "<div id=\"pre-info-form-dialog\" class=\"modal-style modal-rules xl-flexbox xl-left\">\n    <div class = \"modal-in\">\n        <div class=\"modal-content-gray\">\n            <span ng-bind-html=\"$ctrl.aggreement\"></span>\n        </div>\n        <span class=\"close-modalA btn btn-primary\" ng-click=\"$ctrl.close()\">\n            <span translate>common.button.close</span>\n        </span>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/buy/pre-info-form-dialog/pre-info-form-dialog.html
// module id = 521
// module chunks = 0